<template>
    <!-- 人员管理 -->
    <div>
      <div class="fourthStep">
        <el-form
          ref="extTable"
          :model="{ extTable }"
          :rules="tableRules"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item class="addTabIndex" label-width="0px" label="" prop="">
            <el-table border :data="extTable" class="" max-height="99999">
              <el-table-column
                type="index"
                label="序号"
                width="60"
                fixed>
              </el-table-column>
              <el-table-column width="120px;" prop="titleName" label="年份">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`extTable.${scope.$index}.year`"
                    :rules="tableRules.year"
                  >
                    <el-date-picker
                          style="width: 100px;"
                          v-model="scope.row.year"
                          value-format="yyyy"
                          type="year"
                          placeholder="选择年"
                        >
                    </el-date-picker>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column width="170px;" prop="remark" label="资产负债率(%)">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`extTable.${scope.$index}.assetLiabilityRatio`"
                    :rules="tableRules.assetLiabilityRatio"
                  >
                    <el-input
                      style="width: 150px"
                      v-model="scope.row.assetLiabilityRatio"
                      v-input.float2="4"
                      placeholder="请输入"
                      clearable
                      maxlength="18"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column width="140px;" prop="remark" label="流动比率(%)">
                <template slot-scope="scope">
                    <el-form-item
                    :prop="`extTable.${scope.$index}.currentRatio`"
                    :rules="tableRules.currentRatio"
                  >
                    <el-input
                      style="width: 120px"
                      v-model="scope.row.currentRatio"
                      v-input.float2="4"
                      placeholder="请输入"
                      clearable
                      maxlength="18"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column width="170px;" prop="remark" label="营业现金比率(%)">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`extTable.${scope.$index}.operatingCashRatio`"
                    :rules="tableRules.operatingCashRatio"
                  >
  
                    <el-input
                      style="width: 150px"
                      v-model="scope.row.operatingCashRatio"
                      v-input.float2="4"
                      placeholder="请输入"
                      clearable
                      maxlength="18"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column  prop="remark" label="总资产(万元)" width="160px;">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`extTable.${scope.$index}.totalAssets`"
                    :rules="tableRules.totalAssets"
                  >
  
                    <el-input
                      style="width: 140px"
                      v-model="scope.row.totalAssets"
                      v-input.float2="6"
                      placeholder="请输入"
                      clearable
                      maxlength="22"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column  prop="remark" label="营业收入(万元)" width="160px;">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`extTable.${scope.$index}.businessIncome`"
                    :rules="tableRules.businessIncome"
                  >
                  <el-input
                    style="width: 140px;"
                    v-model="scope.row.businessIncome"
                    v-input.float2="6"
                    placeholder="请输入"
                    maxlength="22"
                    clearable
                  />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column  prop="remark" label="企业所得税(万元)" width="160px;">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`extTable.${scope.$index}.taxAmount`"
                    :rules="tableRules.taxAmount"
                  >
                  <el-input
                    style="width: 140px;"
                    v-model="scope.row.taxAmount"
                    v-input.float2="6"
                    placeholder="请输入"
                    maxlength="22"
                    clearable
                  />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                width="100px;"
                prop="remark"
                label="操作"
              >
                <template slot-scope="scope">
                  <span
                    style="color: red;cursor: pointer;"
                    @click="deleteItem(scope)"
                    >删除</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label-width="0px" label="">
            <div class="addBtn" @click="addTable()">+添加财务能力</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      extTable: {
        type: Array,
        default: []
      }
    },
  
    data() {
      return {
        checkOut:false,
        tableRules: {
          year: [
            { required: true, message: '请选择年份', trigger: 'change' }
          ],
          currentRatio: [
            { required: true, message: "请输入流动比率", trigger: "blur" },
          ],
          operatingCashRatio: [
            { required: true, message: "请输入营业现金比率", trigger: "blur" },
          ],
          totalAssets: [
            {
              required: true,
              message: "请输入总资产",
              trigger: "blur"
            }
          ],
          businessIncome: [
            { required: true, message: "请输入营业收入", trigger: "blur" },
          ],
          taxAmount: [
            { required: true, message: "请输入企业所得税", trigger: "blur" },
          ],
          assetLiabilityRatio: [
            { required: true, message: "请输入资产负债率", trigger: "blur" },
          ],
        }
      };
    },
    methods: {
      ruleFun() {
        this.$refs["extTable"].validate(valid => {
          if (valid) {
            this.checkOut=  true;
            } else {
            this.$refs.extTable.$el.scrollIntoView({
              block: "center",
              behavior: "smooth",
            });
            this.checkOut=  false;
          }
        });
      },
      // 新增
      addTable() {
        if (this.extTable && this.extTable.length === 0) {
          this.extTable.push({
            id: 1
          });
        } else {
          this.extTable.push({
            id: this.extTable[this.extTable.length - 1].id + 1
          });
        }
      },
      deleteItem(scope) {
        this.extTable.filter((item, index) => {
          if (item.id === scope.row.id) {
            this.extTable.splice(index, 1);
          }
        });
      },
      // 上一步
      lastStep() {
        this.$emit("getStep", 2);
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .fourthStep {
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.el-table /deep/th.gutter {
  display: table-cell !important;
}
.addBtn {
  cursor: pointer;
  margin: 20px 0px 10px 0px;
  width: 1006px;
  height: 32px;
  line-height: 32px;
  border: 1px dashed #eee;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #252631;
}
.addTabIndex {
  width: 100%;
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.addTabIndex /deep/.tbody tr {
  height: 45px !important;
}
/deep/ .el-input--suffix .el-input__inner {
  padding-right: 0px;
}
.addTabIndex /deep/.el-table {
  width: 1006px;
  margin: 0 auto;
  border-bottom: none;
  tbody tr {
    height: 60px !important;
  }
  .addBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    border: 1px dashed #eee;
    border-radius: 4px;
    margin: 16px 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #252631;
  }

  th>.cell:before{
    content: "*";
    color: red;
    margin-right: 5px;
  }
  th:nth-child(9)>.cell:before{
    content: "";
    margin-right: 5px;
  }
  th:nth-child(1)>.cell:before{
    content: "";
    margin-right: 5px;
  }
}
.table_title {
  width: 100%;
  line-height: 40px;
  border: 1px solid #EDF2FC;
  border-bottom: 0px;
  box-sizing: border-box;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #f8fafd;
}
  </style>
  